export default __webpack_public_path__ + "static/media/bulgary.1ea55c24.svg";